module.exports = __webpack_public_path__ + "img/ch2.3314c264.png";